export const companyPortfolio = {
  'companyPortfolio.portfolioTitle': 'Portfolio',

  'companyPortfolio.productAndServices': 'Naši produkti in storitve',

  'companyPortfolio.modalTitle': 'Uredite portfolio',
  'companyPortfolio.modalPortfolioPlaceholderText': 'Vnesite portfolio',
}
